import {
  getCommunityDataForAnalytics,
  trackGAEvent,
  trackGAEventWithCommunityAndUser
} from '@/utility/analytics';
import {
  HOME_DELETE_ANNOUNCEMENT_EVENT,
  HOME_EDIT_ANNOUNCEMENT_EVENT,
  HOME_PIN_ANNOUNCEMENT_EVENT,
  HOME_UNPIN_ANNOUNCEMENT_EVENT
} from '@/utility/analyticsConsts';

import {
  VISIBILITY_TYPE_MEMBERS,
  VISIBILITY_TYPE_PUBLIC
} from '../Feed/utils';

const _getDataForAnalytics = (postId, user, community) => {
  const communityDataForAnalytics =
    getCommunityDataForAnalytics(community);

  const params = {
    postId,
    email: user?.email,
    ...communityDataForAnalytics
  };

  return params;
};

export const trackEditAnnouncement = (postId, user, community) => {
  const params = _getDataForAnalytics(postId, user, community);
  trackGAEventWithCommunityAndUser(HOME_EDIT_ANNOUNCEMENT_EVENT, params);
};

export const trackPinAnnouncement = (postId, user, community) => {
  const params = _getDataForAnalytics(postId, user, community);
  trackGAEventWithCommunityAndUser(HOME_PIN_ANNOUNCEMENT_EVENT, params);
};

export const trackUnpinAnnouncement = (postId, user, community) => {
  const params = _getDataForAnalytics(postId, user, community);
  trackGAEvent(HOME_UNPIN_ANNOUNCEMENT_EVENT, params);
};

export const trackDeleteAnnouncement = (postId, user, community) => {
  const params = _getDataForAnalytics(postId, user, community);
  trackGAEvent(HOME_DELETE_ANNOUNCEMENT_EVENT, params);
};

export const getDefaultVisibilityType = (community) => {
  if (community?.request_approval || community?.isPaidCommunity) {
    return VISIBILITY_TYPE_MEMBERS;
  }
  return VISIBILITY_TYPE_PUBLIC;
};
